module.exports = ".stats-container {\n  margin: 30px 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/dashboard/dashboard.component.scss
// module id = ./src/app/pages/dashboard/dashboard.component.scss
// module chunks = main